import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll($, projectId, { excludeArchived = false } = {}) {
    const path = `/event/${projectId}/space`
    const config = excludeArchived ? { params: { archived: "false" } } : undefined
    let results = (await HTTP.get(path, config)).data
    return results
  },

  async archive(spaceId, archived = true) {
    const path = `/event/space/${spaceId}/archive`
    return (await HTTP.post(path, { archived })).data
  },

  async get(actionId) {
    const path = `/event/space/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(projectId, notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`event/${projectId}/space`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/event/space/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/event/space/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
